export default __webpack_public_path__ + "static/media/img-guide-03@2x.28be0ce4.png";